import { render } from "./MailConfigEdit.vue?vue&type=template&id=588d1ae3"
import script from "./MailConfigEdit.vue?vue&type=script&lang=js"
export * from "./MailConfigEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__